/**
 * EmptyState component
 * Displays a friendly message when a section has no items
 */

export interface EmptyStateProps {
  /** Message to display */
  message: string;
}

/**
 * EmptyState - Reusable empty state component with centered message
 */
export function EmptyState({ message }: EmptyStateProps) {
  return <p className="text-sm text-gray-500 py-8 text-center">{message}</p>;
}
